import gql from 'graphql-tag';
import { toastr } from 'react-redux-toastr';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import getDriver from '../../routes/site-admin/editDriver/getDriver.graphql';

const LOADER = 'DriverPriorityOverride';

async function runOverrideMutation({ client, dispatch, mutation, name, variables, profileId, successMessage }) {
  dispatch(setLoaderStart(LOADER));

  try {
    const { data } = await client.mutate({
      mutation,
      variables,
      refetchQueries: [{ query: getDriver, variables: { id: Number(profileId) } }]
    });

    const result = data && data[name];
    if (result && result.status === 200) {
      toastr.success('Success!', successMessage);
      return true;
    }

    toastr.error('Error!', (result && result.errorMessage) || 'Failed to update driver priority');
    return false;
  } catch (error) {
    toastr.error('Error!', error.message);
    return false;
  } finally {
    dispatch(setLoaderComplete(LOADER));
  }
}

export function setDriverPriorityOverride(driverId, priorityPercent, reason, profileId) {
  return async (dispatch, getState, { client }) => runOverrideMutation({
    client,
    dispatch,
    name: 'setDriverPriorityOverride',
    mutation: gql`
      mutation setDriverPriorityOverride($driverId: ID!, $priorityPercent: Int!, $reason: String) {
        setDriverPriorityOverride(driverId: $driverId, priorityPercent: $priorityPercent, reason: $reason) {
          status
          errorMessage
        }
      }
    `,
    variables: { driverId, priorityPercent, reason },
    profileId,
    successMessage: `Driver priority set to ${priorityPercent}%.`
  });
}

export function clearDriverPriorityOverride(driverId, profileId) {
  return async (dispatch, getState, { client }) => runOverrideMutation({
    client,
    dispatch,
    name: 'clearDriverPriorityOverride',
    mutation: gql`
      mutation clearDriverPriorityOverride($driverId: ID!) {
        clearDriverPriorityOverride(driverId: $driverId) {
          status
          errorMessage
        }
      }
    `,
    variables: { driverId },
    profileId,
    successMessage: 'Driver acceptance is back to automatic.'
  });
}
